<template>
  <svg
    width="512"
    height="512"
    viewBox="-58 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M219.15 218.1C216.03 214.98 210.96 214.98 207.84 218.1C205.25 220.69 201.8 222.12 198.13 222.12C194.46 222.12
      191.01 220.69 188.42 218.1C185.3 214.98 180.23 214.98 177.11 218.1C173.99 221.22 173.99 226.29
      177.11 229.41C182.73
      235.03 190.19 238.12 198.14 238.12C206.09 238.12 213.54 235.03 219.17 229.41C222.29 226.29 222.29 221.22 219.17
      218.1H219.15Z"
      fill="currentColor"
    />
    <path
      d="M323.18 478.66L317.62 450.27L306.44 393.19C305.59 388.85 301.39 386.03 297.05 386.88C292.71
      387.73 289.89 391.93
      290.74 396.27L311.81 503.8C313.7 514.06 329.65 510.85 327.51 500.72L323.19 478.65L323.18 478.66Z"
      fill="currentColor"
    />
    <path
      d="M99.21 386.88C94.88 386.03 90.67 388.86 89.82 393.19L68.75 500.72C66.61 510.85 82.56 514.05 84.45 503.8L105.52
      396.27C106.37 391.93 103.54 387.72 99.21 386.87V386.88Z"
      fill="currentColor"
    />
    <path
      d="M393.83 501.48C393.79 501.04 389.44 457.34 379.77 411.59C366.18 347.32 349.49 311.14 328.76 300.98C318.37
      295.89 289.1 285.86 272.58 279.99L267.68 278.04C260.1 275.02 252.33 271.87 244.54 268.64C243.33 268.14 242.03
      267.06 242.03 265.55V258.91C263.34 246.54 279 225.47 284.09 200.59C301.71 197.62 315.17
      182.26 315.17 163.82C315.17
      155.02 312.14 146.7 306.59 140.02V78.62C306.59 36.52 272.34 2.27 230.24 2.27H172.21C145.09 2.27 122.61 22.5 119.07
      48.67C102.31 52.15 89.67 66.53 89.67 84.81V140.02C84.11 146.7 81.09 155.03 81.09 163.82C81.09 182.27 94.55 197.62
      112.17 200.59C117.26 225.47 132.92 246.55 154.23 258.92V265.56C154.23 267.07 152.93 268.14 151.72 268.65C137.06
      274.71 121.77 280.15 108.28 284.95C91.76 290.83 77.5 295.9 67.11 300.99C46.38 311.16 29.69 347.34 16.1 411.6C6.42
      457.35 2.08 501.05 2.04 501.49C1.61 505.89 4.82 509.8 9.22 510.23C9.49 510.25 9.75 510.27 10.01 510.27C14.08
      510.27 17.56 507.18 17.96 503.05C18 502.62 22.28 459.68 31.78 414.78C47.95 338.42 65.27 319.71 74.16 315.35C83.73
      310.66 97.59 305.73 113.65 300.02C117.42 298.68 121.34 297.28 125.34 295.84L147.85 334.83C150.04 338.82 155.67
      340.08 159.35 337.4L190.13 315.99V502.27C189.98 512.65 206.28 512.65 206.13 502.27V315.99L236.91 337.4C240.6
      340.08 246.21 338.82 248.41 334.83L270.59 296.41C286.64 302.12 312.15 310.67 321.71 315.36C330.6 319.72 347.92
      338.43 364.09 414.79C373.6 459.69 377.87 502.63 377.91 503.06C378.31 507.19 381.8 510.28 385.86 510.28C386.12
      510.28 386.39 510.27 386.65 510.24C391.05 509.81 394.26 505.89 393.83 501.49V501.48ZM299.17 163.82C299.17
      172.74 293.66 180.4 285.87 183.56V144.06C288.48 145.12 290.88 146.7 292.93 148.75C296.95 152.77 299.17 158.12
      299.17 163.81V163.82ZM134.58 55.89C134.58 35.11 151.43 18.26 172.21 18.26H230.24C263.57 18.26 290.59 45.28 290.59
      78.61V128.73C286.57 127.27 282.28 126.51 277.87 126.51C207.15 126.51 178.44 116.49 167.58 110.49C163.45 108.21
      159.07 106.41 154.57 104.99C150.94 103.84 146.57 101.72 142.65 97.79C136.62 91.72 135.04 84.74
      134.58 82.09V55.88V55.89ZM97.09
      163.82C97.09 158.13 99.31 152.78 103.33 148.76C105.38 146.71 107.78 145.12 110.39 144.07V183.57C102.6 180.4 97.09
      172.75 97.09 163.83V163.82ZM105.67 128.74V84.81C105.67 76.11 111.01 68.64 118.58 65.49V82.1C118.58 98.41 129.44
      112.22 144.3 116.71C141.22 121.31 134.23 126.52 118.39 126.52C113.98 126.52 109.69 127.28 105.67 128.74ZM126.39
      182.98V142.12C144.17 140.25 153.92 132.17 158.73 123.9C172.69 132 203.29 141.75 269.87 142.48V182.98C269.87 222.54
      237.69 254.72 198.13 254.72C158.57 254.72 126.39 222.54 126.39 182.98ZM157.35 319.29L140.57
      290.23C144.04 288.92 147.53
      287.57 151.02 286.18C155.11 292.5 162.97 301.07 177.04 305.59L157.35 319.29ZM198.13 292.67
      C178.48 292.67 169.12 284.12
      165.08 278.43C168.2 275.08 170.06 270.76 170.21 266.15C178.98 269.1 188.37 270.7 198.13 270.7C207.89 270.7 217.28
      269.1 226.05 266.14C226.2 270.75 228.06 275.07 231.18 278.42C227.13 284.1 217.78 292.66 198.13
      292.66V292.67ZM238.9
      319.29L219.21 305.59C233.25 301.08 241.11 292.53 245.2 286.22C248.67 287.64 252.13 289.04
      255.56 290.42L238.9 319.28V319.29Z"
      fill="currentColor"
    />
  </svg>
</template>
